/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React, { Component } from "react";
import { logErrorBoundaryInfo } from "logging/logToServer";
import localizeComponent from "dc-preview-utils/src/Utils/LocalizationUtil";
import loadTranslation from "utils/TranslationUtil";
import RefExposer from "app/RefExposer";

// polyfill to allow using forEach for NodeLists returned by querySelectorAll.
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function(callback, thisArg) {
    thisArg = thisArg || window;
    for (var i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

class PreviewDropinWrapper extends Component {
  constructor(props) {
    super(props);
    const { locale } = this.props;
    this.LocalizedApp = localizeComponent(RefExposer, loadTranslation, { locale });
  }

  componentDidCatch(error, info) {
    logErrorBoundaryInfo("%O", {
      componentStack: info.componentStack,
      errorStack: error.stack
    });
  }

  render() {
    return <this.LocalizedApp {...this.props} />;
  }
}

export default PreviewDropinWrapper;
